<template>
    <section class="VibeTestimonialSection container relative flex w-full flex-col items-center max-md:max-w-full">
        <h2 class="text-4xl font-semibold text-[#282828] max-md:max-w-full">
            <slot />
        </h2>
        <div class="mt-14 w-full self-stretch max-md:mt-10 max-md:max-w-full">
            <div class="flex gap-5 max-md:flex-col">
                <div class="flex w-6/12 flex-col max-md:ml-0 max-md:w-full">
                    <VibeTestimonialCard v-bind="testimonials[0]" />
                </div>
                <div class="ml-5 flex w-6/12 flex-col max-md:ml-0 max-md:w-full">
                    <VibeTestimonialCard v-bind="testimonials[1]" />
                </div>
            </div>
        </div>

        <img
            alt=""
            class="-bottom-32 -left-56 -z-1 w-[100px] object-contain max-sm:mt-8 sm:absolute sm:w-[350px]"
            src="@/assets/images/vibe/vibe-man-glass.png"
        />
    </section>
</template>

<script setup lang="ts">
import VibeTestimonialCard, { type TestimonialProps } from '@/components/vibe/VibeTestimonialCard.vue'
import { type PropType } from 'vue'

defineProps({
    message: {
        type: String,
        default: ''
    },
    testimonials: {
        type: Array as PropType<TestimonialProps[]>,
        required: true
    }
})
</script>
